import FormControl from "@material-ui/core/FormControl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import Delete from "@material-ui/icons/Delete";

import ViewList from "@material-ui/icons/ViewList";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from 'axios';
import Badge from "components/Badge/Badge";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import moment from "moment";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import Datetime from "react-datetime";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { api_url } from 'redux/config.js';
import { getScoreOfOneResponse } from "utils/Score";
import Toast from 'views/Toast/Toast';
import { TransReactTable } from "components/CustomReactTable/TransReactTable";
import { withTranslation } from "react-i18next";
import { t } from "i18next";

const styles = {
  ...regularFormsStyle,
  customInput: {
    marginBottom: 17
  }
};

class SurveyRespondentsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      responseData: [],
      survey: null,
      survey_id: 0,

      filterData: {
        from: Date.now(),
        to: Date.now(),
        emailidpass: "",
        location: "",       // exact or comma-separated list
        locationFrom: "",   // numeric range start
        locationTo: "",     // numeric range end
        scoreFrom: "",      // overall score range, e.g. 3.8 – 5 for the guests to invite
        scoreTo: "",
      },
      selected: {},         // response id -> true, for the export
      loading: false,
      pages: -1,
      pageSize: 20,
      paginationState: {},
    };
  }

  // The 'reports' sub-user studies answers without guest identities (the server blanks them too).
  isReportsOnly = () => !!(this.props.user.profile && this.props.user.profile.sub_role === 'reports');

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);

    this.setState({
      survey_id: urlParams.get("id"),
    })

    this.getSurvey(urlParams.get("id"));
  }
  setFilterData = (name, value) => {
    let filterData = this.state.filterData;
    filterData[name] = value;
    this.setState({
      filterData
    })
  }
  getSurvey = (id) => {
    let self = this;
    const urlParams = new URLSearchParams(this.props.location.search);

    const url = api_url + `survey/get?id=${id}`;
    const header = 'Bearer '.concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: 'LOAD_START' });
    axios({
      url,
      method: 'get',
      headers,
    })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            survey: response.data.data
          }, () => self.normalizeData(response.data.data.responses));
        } else {
          Toast(400, response.data.error)
        }
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };
  remove = (survey_id, response_id) => {
    if (window.confirm(t('Are you sure?'))) {
      const self = this;
      const url = api_url + `survey/remove_response`;

      let headers = null;
      const header = 'Bearer '.concat(this.props.user.token);

      if (this.props.user.token) {
        headers = {
          Authorization: header
        };
      }
      this.props.dispatch({ type: 'LOAD_START' });
      axios({
        url,
        method: 'delete',
        headers,
        params: {
          survey_id,
          response_id
        }
      })
        .then(function (response) {
          if (response.data.success) {

            const { responseData } = self.state
            const newData = responseData.filter((item) => item.id != response_id);
            self.setState({
              responseData: newData
            })
          } else {
            Toast(400, response.data.error)
          }
          self.props.dispatch({ type: 'LOAD_END' });
        })
        .catch(function (errors) {
          console.info(errors);
          self.props.dispatch({ type: 'LOAD_END' });
          if (!errors.response) {
            Toast(500);
            return;
          }
          Toast(errors.response.status);
        });
    }
  }
  // The overall score of one response, the same number the reports show. Kept in one place because
  // both the score filter and the table need it.
  scoreOf = (item) => {
    const questions = (this.state.survey || {}).questions || []
    return getScoreOfOneResponse(questions[0], item.answers)
  }

  normalizeData = (responses) => {
    const survey = this.state.survey
    const ndata = responses.map((item, key) => {
      const action = (
        <div key={key}>

          <Button
            justIcon
            size="sm"
            color="info"
            onClick={
              () => {
                const params = {
                  survey_id: survey.id,
                  response_id: item.id
                }
                var win = window.open(`/public/survey_answer/${params.survey_id}/${params.response_id}`, '_blank');
                win.focus();
              }
            }
          >
            <RemoveRedEye />
          </Button>
          {!this.isReportsOnly() &&
            <Button
              justIcon
              size="sm"
              color="danger"
              onClick={() => this.remove(survey.id, item.id)}
            >
              <Delete />
            </Button>}
        </div>
      );
      const score = this.scoreOf(item)
      return {
        _id: item.id,
        emailidpass: item.emailidpass,
        email: item.email || '',
        location: item.location || '',
        guest: item.guest_name || '',
        date: moment(item.created_at).format("MMMM Do YYYY, h:mm:ss a"),
        score: score.toFixed(2),
        action
      };
    });
    // Selections belong to the rows that are on screen: keep only the ones that survived the filter,
    // so an export can never include a row the user can no longer see.
    const stillThere = {};
    ndata.forEach(r => { if (this.state.selected[r._id]) stillThere[r._id] = true });
    this.setState({
      responseData: ndata,
      selected: stillThere,
    })
  }

  toggleOne = (id) => {
    const selected = Object.assign({}, this.state.selected);
    if (selected[id]) delete selected[id]; else selected[id] = true;
    this.setState({ selected });
  }
  toggleAll = () => {
    const rows = this.state.responseData;
    const allOn = rows.length > 0 && rows.every(r => this.state.selected[r._id]);
    const selected = {};
    if (!allOn) rows.forEach(r => { selected[r._id] = true });
    this.setState({ selected });
  }

  // Export what is on screen, or just the ticked rows when any are ticked. `emailsOnly` writes a
  // single de-duplicated column, which is what a mailing tool wants.
  exportCsv = (emailsOnly) => {
    const rows = this.state.responseData;
    const anySelected = Object.keys(this.state.selected).length > 0;
    const chosen = anySelected ? rows.filter(r => this.state.selected[r._id]) : rows;
    if (!chosen.length) { Toast(400, t('Nothing to export')); return; }

    const cell = (v) => {
      const s = String(v == null ? '' : v);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    let csv;
    let name;
    if (emailsOnly) {
      const seen = new Set();
      const list = [];
      chosen.forEach(r => {
        const addr = String(r.email || r.emailidpass || '').trim();
        const key = addr.toLowerCase();
        if (!addr || addr.indexOf('@') < 0 || seen.has(key)) return;   // ids/passwords are not addresses
        seen.add(key);
        list.push(addr);
      });
      if (!list.length) { Toast(400, t('No email addresses in the selected rows')); return; }
      csv = ['email'].concat(list).join('\n');
      name = 'respondents_emails.csv';
    } else {
      const header = ['email', 'location', 'guest', 'date', 'score'];
      csv = [header.join(',')].concat(
        chosen.map(r => [r.email || r.emailidpass, r.location, r.guest, r.date, r.score].map(cell).join(','))
      ).join('\n');
      name = 'respondents.csv';
    }

    try {
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });   // BOM for Excel
      if (window.navigator && window.navigator.msSaveBlob) { window.navigator.msSaveBlob(blob, name); return; }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
    }
  }
  sendFilterData = () => {
    const filterData = this.state.filterData
    const responseData = this.state.survey.responses

    const from = moment(filterData.from).startOf('day').valueOf()
    const to = moment(filterData.to).endOf('day').valueOf()

    const locList = (filterData.location || '').split(',').map(s => s.trim()).filter(Boolean)
    const lFrom = filterData.locationFrom !== '' && filterData.locationFrom != null ? parseInt(filterData.locationFrom, 10) : null
    const lTo = filterData.locationTo !== '' && filterData.locationTo != null ? parseInt(filterData.locationTo, 10) : null
    const hasRange = lFrom !== null || lTo !== null

    const sFrom = filterData.scoreFrom !== '' && filterData.scoreFrom != null ? parseFloat(filterData.scoreFrom) : null
    const sTo = filterData.scoreTo !== '' && filterData.scoreTo != null ? parseFloat(filterData.scoreTo) : null

    const filtered = responseData.filter((item) => {
      const created_at = moment(item.created_at).valueOf()
      // Inclusive at both ends: `from` is the start of the day and `to` its last millisecond, so a
      // response at exactly midnight belongs to the range.
      if (!(created_at >= from && created_at <= to)) return false
      if (filterData.emailidpass.length > 0 && (item.emailidpass || '').indexOf(filterData.emailidpass.trim()) < 0) return false
      if (locList.length > 0 || hasRange) {
        const loc = (item.location || '').trim()
        if (!loc) return false
        let ok = false
        if (locList.length > 0 && locList.indexOf(loc) >= 0) ok = true
        if (!ok && hasRange) {
          const n = parseInt(loc, 10)
          if (!isNaN(n) && (lFrom === null || n >= lFrom) && (lTo === null || n <= lTo)) ok = true
        }
        if (!ok) return false
      }
      if (sFrom !== null || sTo !== null) {
        const sc = this.scoreOf(item)
        // A response with no rating answered scores 0; it is not "low", it is absent, so a score
        // range never matches it.
        if (!(sc > 0)) return false
        if (sFrom !== null && sc < sFrom) return false
        if (sTo !== null && sc > sTo) return false
      }
      return true
    })
    this.normalizeData(filtered)
  }
  render() {
    const { classes } = this.props;
    const { survey } = this.state
    if (!survey) return null;

    const rows = this.state.responseData;
    const selectedCount = Object.keys(this.state.selected).length;
    const allOn = rows.length > 0 && rows.every(r => this.state.selected[r._id]);

    // A 'reports' sub-user studies the answers, not the guests: the server already blanks the
    // addresses for this role, and the page drops the column, the e-mail export and deletion.
    const reportsOnly = this.isReportsOnly();
    const column = [
      {
        // Rendered through Cell (not baked into the row data) so ticking a box re-renders the
        // checkbox from state instead of leaving a stale element behind.
        id: "select",
        Header: () => (
          <input type="checkbox" checked={allOn} onChange={this.toggleAll}
            title={t('Select all shown')} style={{ cursor: 'pointer' }} />
        ),
        accessor: "_id",
        sortable: false,
        filterable: false,
        width: 45,
        Cell: (row) => (
          <input type="checkbox" style={{ cursor: 'pointer' }}
            checked={!!this.state.selected[row.original._id]}
            onChange={() => this.toggleOne(row.original._id)} />
        ),
      },
      ...(reportsOnly ? [] : [{
        // An SMS respondent has no address; the column holds their number instead, which is what
        // identifies them. Naming it after email alone made those rows look empty.
        Header: t("Email / Phone"),
        accessor: "emailidpass"
      }]),
      {
        Header: t('Location'),
        accessor: "location"
      },
      {
        Header: t('Guest'),
        accessor: "guest"
      },
      {
        Header: t('Date'),
        accessor: "date"
      }, {
        Header: t('Score'),
        accessor: "score"
      },
      {
        Header: t('Actions'),
        accessor: "action",
        sortable: false,
        minWidth: 150
      }
    ];
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <ViewList />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{survey.title}</h4>
              </CardHeader>
              <CardBody>
                <p>
                  {t('Total Resonses')} <Badge color="info">{survey.responses.length}</Badge>
                </p>

              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('Filter')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>

                  <GridItem xs={12} md={12}>
                    <CustomInput
                      labelText={t('Search by E-mail OR by ID OR password')}
                      id="Title"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: (e) => this.setFilterData('emailidpass', e.target.value)
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText={t('Location — exact / list (e.g. 205, 210)')}
                      id="respLocation"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: "text", onChange: (e) => this.setFilterData('location', e.target.value) }}
                    />
                  </GridItem>
                  <GridItem xs={6} md={3}>
                    <CustomInput
                      labelText={t('Location range from')}
                      id="respLocationFrom"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: "number", onChange: (e) => this.setFilterData('locationFrom', e.target.value) }}
                    />
                  </GridItem>
                  <GridItem xs={6} md={3}>
                    <CustomInput
                      labelText={t('Location range to')}
                      id="respLocationTo"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: "number", onChange: (e) => this.setFilterData('locationTo', e.target.value) }}
                    />
                  </GridItem>
                  <GridItem xs={6} md={3}>
                    <CustomInput
                      labelText={t('Score from (e.g. 3.8)')}
                      id="respScoreFrom"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        type: "number", step: "0.1",
                        onChange: (e) => this.setFilterData('scoreFrom', e.target.value)
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} md={3}>
                    <CustomInput
                      labelText={t('Score to (e.g. 5)')}
                      id="respScoreTo"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        type: "number", step: "0.1",
                        onChange: (e) => this.setFilterData('scoreTo', e.target.value)
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth>
                      <Datetime
                        className={classes.customInput}
                        timeFormat={false}
                        inputProps={{ placeholder: "From" }}
                        onChange={(e) => this.setFilterData('from', e.valueOf())}
                        value={this.state.filterData.from}
                        dateFormat="DD/MM/YYYY"
                        closeOnSelect={true}

                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth>
                      <Datetime
                        className={classes.customInput}
                        timeFormat={false}
                        inputProps={{ placeholder: "To" }}
                        onChange={(e) => this.setFilterData('to', e.valueOf())}
                        value={this.state.filterData.to}
                        closeOnSelect={true}
                        dateFormat="DD/MM/YYYY"

                      />
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth>
                      <Button color="success" size="sm" onClick={() => {

                        this.sendFilterData();
                      }}>{t('Send Filter')}</Button>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={12}>
            <div style={{
              display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8,
              margin: '0 0 10px',
            }}>
              <Button color="info" size="sm" onClick={() => this.exportCsv(false)}>
                {t('Export CSV')}
              </Button>
              {!this.isReportsOnly() &&
                <Button color="info" size="sm" onClick={() => this.exportCsv(true)}>
                  {t('Export e-mails')}
                </Button>}
              <span style={{ fontSize: 13, color: '#5d6d66' }}>
                {selectedCount > 0
                  ? t('{n} selected').replace('{n}', selectedCount)
                  : t('{n} shown — exports all of them unless you tick some')
                    .replace('{n}', rows.length)}
              </span>
            </div>
            <TransReactTable
              defaultPageSize={this.state.pageSize}
              data={this.state.responseData}
              columns={column}

            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}


const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(SurveyRespondentsPage)));